import React from "react";
import { Button, Row, Col } from "shards-react";
import { useTranslation } from "react-i18next";

import useCurrentUser from "shared/hook/useCurrentUser";

const FormLoginSucceed = (props) => {
  const { t } = useTranslation();
  const { curruntUser } = useCurrentUser();
  const startWebPage = () => {
    window.location = "/";
  };
  return (
    <>
      <Row>
        <Col className="pt-5 pb-5 mt-5 mb-5 text-center" md="12">
          {curruntUser && (
            <h5 className="bold">
              {t("common:logIn.Hello")} {curruntUser.user.firstName}
            </h5>
          )}
          <h6>{t("common:logIn.WelcomeToLogin")}</h6>
        </Col>
      </Row>
      <Row>
        <Col md="12">
          <Button className="btn btn-success w-100 mb-3" onClick={startWebPage}>
            {t("common:logIn.GetStarted")}
          </Button>
        </Col>
      </Row>
    </>
  );
};

export default FormLoginSucceed;
